<template>
  <div>
    <div v-if="$page.props.user && $page.props.user.is_temp_user"
         class="text-center bg-green-100 border-green-500 text-green-700 p-4" role="alert">
      <p>Your account is a temporary user, convert it into a full user for free and explore more features today.
      </p>
    </div>
    <register></register>
  </div>
</template>

<script>


import Login from "@/Pages/Auth/Login";
import Register from "@/Pages/Auth/Register";
export default {
  components: {Register, Login},

}
</script>
